export default {
  "content-text": () => import("/vercel/path0/layouts/content-text.vue"),
  default: () => import("/vercel/path0/layouts/default.vue")
}